import { useEffect, useState } from "react";
import { Truck } from "lucide-react";

const LANES = ["Jamshedpur → Kolkata", "Hazira → Ahmedabad", "Ghaziabad → Lucknow", "Jalna → Pune", "Bellary → Bengaluru", "Kanpur → Patna", "Faridabad → Jaipur", "Chennai → Kochi"];
const DAY_START = 12;
const DAY_EXTRA = 10;

const baseCount = () => {
  const now = new Date();
  const mins = now.getHours() * 60 + now.getMinutes();
  return DAY_START + 1 + Math.floor((mins / 1440) * DAY_EXTRA);
};

function useDispatchTicker() {
  const [count, setCount] = useState(baseCount);
  const [lane, setLane] = useState(0);
  const [bump, setBump] = useState(false);

  useEffect(() => {
    const id = setInterval(() => {
      const next = baseCount();
      setCount((c) => {
        if (next !== c) {
          setLane((l) => (l + 1) % LANES.length);
          setBump(true);
          setTimeout(() => setBump(false), 600);
        }
        return next;
      });
    }, 60000);
    return () => clearInterval(id);
  }, []);
  return { count, lane: LANES[lane], bump };
}

export function MobileDispatchStrip() {
  const { count, lane, bump } = useDispatchTicker();
  return (
    <div className="hero-glass md:hidden mt-3 mx-auto w-full max-w-sm flex items-center gap-3 px-4 py-2.5 rounded-xl border border-ib-steel/20" data-testid="mobile-dispatch-strip">
      <span className="relative flex w-2 h-2 flex-shrink-0"><span className="absolute inset-0 rounded-full bg-ib-lime animate-ping opacity-70" /><span className="relative w-2 h-2 rounded-full bg-ib-lime" /></span>
      <Truck className="w-4 h-4 text-ib-blue flex-shrink-0" />
      <span className={`font-outfit font-extrabold text-base text-ib-text tabular-nums transition-colors ${bump ? "text-ib-blue" : ""}`} data-testid="mobile-dispatch-count">{count}</span>
      <span className="font-manrope text-[11px] font-semibold text-ib-text-secondary whitespace-nowrap">trucks dispatched today</span>
      <span className="ml-auto min-w-0 hidden min-[400px]:block font-jetbrains text-[9px] text-ib-text-muted truncate">{lane}</span>
    </div>
  );
}

export function DispatchCounter() {
  const { count, lane, bump } = useDispatchTicker();
  return (
    <div className="hero-glass absolute z-20 bottom-10 left-10 hidden md:flex items-center gap-4 pl-3 pr-5 py-3 rounded-2xl border border-ib-steel/25 shadow-lg" data-testid="dispatch-counter">
      <div className="relative w-11 h-11 rounded-xl bg-ib-blue flex items-center justify-center">
        <Truck className="w-5 h-5 text-white" />
        <span className="absolute -top-1 -right-1 flex w-3 h-3"><span className="absolute inset-0 rounded-full bg-ib-lime animate-ping opacity-70" /><span className="relative w-3 h-3 rounded-full bg-ib-lime border-2 border-ib-bg" /></span>
      </div>
      <div className="text-left">
        <div className="flex items-baseline gap-2">
          <span className={`font-outfit font-extrabold text-2xl text-ib-text tabular-nums transition-transform duration-300 ${bump ? "scale-110 text-ib-blue" : ""}`} data-testid="dispatch-count">{count}</span>
          <span className="font-manrope text-xs font-semibold text-ib-text-secondary">trucks dispatched today</span>
        </div>
        <div className="font-jetbrains text-[10px] text-ib-text-muted mt-0.5" data-testid="dispatch-lane">Latest: {lane}</div>
      </div>
    </div>
  );
}
